/*----------------------------------
- MEGA MENU PANEL HEADER
----------------------------------*/

import type { ComponentChildren } from 'preact';

/*----------------------------------
- TYPES
----------------------------------*/

type MenuPanelHeaderProps = {
    title: ComponentChildren;
    lead: ComponentChildren;
    /** The action or the status line on the right of the title, when the panel has one. */
    aside?: ComponentChildren;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * The title line every desktop megamenu opens on. Plain text on purpose: a menu label
 * is not part of the page outline, so the shell renders no heading element.
 */
export default function MenuPanelHeader({ title, lead, aside }: MenuPanelHeaderProps) {
    return (
        <div class="flex items-baseline justify-between gap-6">
            <div>
                <div class="text-[22px] font-semibold tracking-[-0.025em] text-slate-950">{title}</div>
                <div class="mt-1 text-sm leading-[1.5] text-[#66696b]">{lead}</div>
            </div>
            {aside ? <div class="flex-none">{aside}</div> : null}
        </div>
    );
}
